import * as accountInfo from './accountInfo';
import * as connectionManager from './connectionManager';
import * as joinBroadcast from './joinBroadcast';
import * as logrocket from './logrocket';
import * as mediaUpload from './mediaUpload';
import * as mixpanel from './mixpanel';
import * as recordings from './recordings';
import * as sso from './sso';

export default [].concat(
  Object.values(accountInfo),
  Object.values(connectionManager),
  Object.values(joinBroadcast),
  Object.values(logrocket),
  Object.values(mediaUpload),
  Object.values(mixpanel),
  Object.values(recordings),
  Object.values(sso)
);
